module.exports = __webpack_public_path__ + "img/background-full.e1664ec5.png";